import { render, staticRenderFns } from "./PriceTag.vue?vue&type=template&id=cb6da590&scoped=true"
import script from "./PriceTag.vue?vue&type=script&lang=js"
export * from "./PriceTag.vue?vue&type=script&lang=js"
import style0 from "./PriceTag.vue?vue&type=style&index=0&id=cb6da590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6da590",
  null
  
)

export default component.exports